import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"



class CategoriaAdmin extends Component {
state = {
  nome:null,
  categorias:[],
  error:null,
  success:null
}



  async componentDidMount(){
   this.loadcategorias();
  }


  async loadcategorias () {
    const response = await api.get("/categorias");
    this.setState({ categorias: response.data });
  }



  addcat = async e => {
    e.preventDefault();
    const { nome } = this.state;
      if (!nome) {
          this.setState({ error: "Preencha o nome antes de adicionar um novo!",
        success:null });
          
      } else {
      const { nome } = this.state;
      const response = await api.post("/admin/categoria/add", { nome });

        if(response.data.id){
          this.setState({ success: "Categoria Adicionada!" , error:null });
          this.loadcategorias();
        }

      }
  }

  render() {
    return (
      <React.Fragment>
          <Header />
        <div class="container col-lg-6 p-4">     

        <h4>Adicionar Nova Categoria</h4>     
        <form onSubmit={this.addcat}>

        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" onChange={e => this.setState({ nome: e.target.value })} placeholder="Digite o nome da nova Categoria" />
                </div>
                <div class="form-group">
                <button class="btn btn-primary mb-2">Adicionar</button>

                </div>
        </form>














    {/* Tables */}

    <table id="dtBasicExample" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%">
  <thead>
    <tr>
      <th class="th-sm">Nome

      </th>
      <th class="th-sm">Ação

      </th>
    </tr>
  </thead>
  <tbody>
  {this.state.categorias.map(el => (
    <tr>
    <td>{el.nome}</td>
    <td>
      <Link class="btn btn-secondary btn-sm" to={'/admin/categoria/edit/'+el.id}>Editar</Link>
      <Link class="btn btn-danger btn-sm" to={'/admin/categoria/remove/'+el.id}>Remover</Link>
    </td>
  </tr>
  ))}
    

   
  </tbody>

</table>

{/* FIm table */}


    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(CategoriaAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/categoria.js